export const SET_PASS_REST = "[APP] SUCCESSFUL PASSWORD RESET";
export const LOGOUT_USER = "[APP] NAVIGATE TO LOGOUT";
export const SHOW_GOBACK = "[APP] SHOW GO BACK BUTTON";
export const USER_STATE = "[APP] USER STATE";
export const API_STATE = "[APP] API STATE";
export const LOADER_STATE = "[APP] LOADER STATE";
